(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !window.DesignMode) return;
  try {
    

    const formElement = document.getElementById('contact-form');

    formElement.setAttribute('onsubmit', "return");
    const config = { attributes: true, childList: true, subtree: true };
    
    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
            if (mutation.type === 'attributes' && mutation.attributeName == 'onsubmit') {
                formElement.setAttribute('onsubmit', "return");
                observer.disconnect();
            }
        }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(formElement, config);

    const contactForm = new JustValidate('#contact-form', {
        errorFieldCssClass: 'is-invalid',
        validateBeforeSubmitting: true,
        // errorsContainer: document.querySelector('.footer-newsletter-errors'),
        errorLabelStyle: {
          paddingTop: '5px',
          cololr: 'white'
        },
        errorFieldCssClass: ['justValidate-invalid'],
      });
  
      contactForm.addField('#first-name', [
        {
          rule: 'required',
        }
      ]).addField("#surname", [
        {
            rule: 'required',
        },
      ]).addField("#message", [
        {
            rule: 'required',
        }
      ]).addField("#email-address", [
        {
            rule: 'required',
        },
        {
            rule: 'email'
        }
      ]).onSuccess((event) => {
        event.preventDefault();
        document.getElementById('contact-form').submit();
      })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !window.DesignMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trade-contact-form"] && !window.DesignMode) return;
  try {
    

    const formElement = document.getElementById('trade-contact-form');

    formElement.setAttribute('onsubmit', "return");
    const config = { attributes: true, childList: true, subtree: true };
    
    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
            if (mutation.type === 'attributes' && mutation.attributeName == 'onsubmit') {
                formElement.setAttribute('onsubmit', "return");
                observer.disconnect();
            }
        }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(formElement, config);

    const tradeContactForm = new JustValidate('#trade-contact-form', {
        errorFieldCssClass: 'is-invalid',
        validateBeforeSubmitting: true,
        // errorsContainer: document.querySelector('.footer-newsletter-errors'),
        errorLabelStyle: {
          paddingTop: '5px',
          cololr: 'white'
        },
        errorFieldCssClass: ['justValidate-invalid'],
      });
  
      tradeContactForm.addField("#business-name", [
        {
            rule: 'required',
        },
      ]).addField("#business-address", [
        {
            rule: 'required',
        }
      ])
      .addField("#contact-name", [
        {
            rule: 'required',
        }
      ])
      .addField("#contact-number", [
        {
            rule: 'required',
        },
        {
          rule: 'number',
        },
      ])
      .addField("#contact-email", [
        {
            rule: 'required',
        },
        {
            rule: 'email',
        },
      ])
      .onSuccess((event) => {
        event.preventDefault();
        document.getElementById('trade-contact-form').submit();
      })

  } catch(e) { console.error(e); }
})();
})();
